export interface IError extends Error {
  code: string;
}

export type User = {
  email: string;
  password: string;
};

export enum AuthErrorResponseMessages {
  USER_NOT_FOUND = 'UserNotFoundException',
  INCORRECT_CREDENTIALS = 'NotAuthorizedException',
  USER_ALREADY_EXISTS = 'UsernameExistsException',
  INVALID_VERIFICATION_CODE = 'CodeMismatchException',
  SERVER_ERROR = 'InternalErrorException',
  NOT_AUTHORIZED = 'NotAuthorizedException',
  TOO_MANY_REQUESTS = 'TooManyRequestsException',
  USER_NOT_CONFIRMED = 'UserNotConfirmedException',
}

export enum AuthForm {
  Signup = 'signup',
  Signin = 'signin',
  ConfirmEmail = 'confirmEmail',
  ForgotPassword = 'forgotPassword',
  ChangePassword = 'changePassword',
}
